module.exports = __webpack_public_path__ + "img/15.36374b10.png";